export default {
  root: ({ props }) => ({
    class: ['w-3/12', 'bg-white', 'rounded-md'],
  }),
  mask: {
    class: ['bg-red-500', 'mask'],
  },
}
